import React, { Component } from 'react';
import { appSetPlate, appSetRoute } from '../../store/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Plate from '../../components/Plate';

class Cplate extends Component {
    constructor(props) {
        super(props);

        this.handleContinue = this.handleContinue.bind(this);        

        this.state = {};        
        this.state.plate = localStorage.getItem('delapp-plate') || '';

        if (this.state.plate){
            this.props.appSetPlate(this.state.plate);
            this.props.appSetRoute('deliv');    
        }
    }

    handleContinue(data) {
        localStorage.setItem('delapp-plate',data);
        this.props.appSetPlate(data);
        this.props.appSetRoute('deliv');
    }

    render() {
        return (
            <Plate
                texts={{
                    continue: this.props.txt_continue,
                    vehiclePlate: this.props.txt_vehiclePlate,
                    plate: this.props.txt_plate
                }}
                plate={this.props.plate || this.state.plate}
                handleContinue={this.handleContinue} />
        );
    }
}

const mapStateToProps = state => {
    const getText = (id) => {
        let text = '';
        try {
            text = state.app.texts[id][state.app.language];
        } catch (err) {
            text = '';
        }
        return text;
    }

    return {
        plate: state.app.plate,

        txt_continue: getText("0036"),
        txt_vehiclePlate: getText("0035"),
        txt_plate: getText("0021")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        appSetPlate: (data) => dispatch(appSetPlate(data)),
        appSetRoute: (route) => dispatch(appSetRoute(route))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Cplate));



// WEBPACK FOOTER //
// ./src/containers/Cplate/index.js